import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { NodeCompetencyAttributesFragment } from 'generated/resources/graphql'

import EmptyState from 'modules/job_catalog/components/TreeNodeAttributes/EmptyState'
import {
  DEFAULT_CATEGORIES,
  NODE_TYPES,
  getTextFromNodeType as getNodeTypeLabel,
  isNodeType,
  nodeTypeIcon,
} from 'modules/job_catalog/lib/nodesUtils'

interface CompetenciesAttributesProps {
  items: NodeCompetencyAttributesFragment[]
}

interface CompetenciesAttributeProps {
  item: NodeCompetencyAttributesFragment
}

const CompetenciesAttribute = ({ item }: CompetenciesAttributeProps) => {
  const competency = item.valueCompetency
  const nodeType = isNodeType(item.definedAt) ? item.definedAt : NODE_TYPES.ROOT
  const icon = nodeTypeIcon(nodeType)
  const label = item.definedAtNode?.name || getNodeTypeLabel(nodeType)

  if (!competency) return null

  return (
    <Box key={item.id} gap="s4">
      <Box flexDirection="row" justifyContent="spaceBetween" paddingRight="s16">
        <Text.Normal weight="semibold" size="200" color="grey1000">
          {competency.name}
        </Text.Normal>
        <F0TagRaw text={label} icon={icon} />
      </Box>
      <Text.Normal weight="normal" size="200" color="grey800">
        {competency.description}
      </Text.Normal>
    </Box>
  )
}

const CompetenciesAttributes = ({ items }: CompetenciesAttributesProps) => {
  if (!items || items.length === 0) {
    return <EmptyState category={DEFAULT_CATEGORIES.COMPETENCIES} />
  }

  return (
    <Box paddingX="s24" gap="s20">
      {items.map((item) => (
        <CompetenciesAttribute key={item.id} item={item} />
      ))}
    </Box>
  )
}

export default CompetenciesAttributes
